import { FC } from 'react';
import styled from 'styled-components';

import { remify } from '#/service/utils';

import { HeadingProps } from '../FormInput.types';

const Text = styled.div`
  font: var(--fontStyleTitle3);
  margin-top: ${remify(48)};
  text-align: left;
`;

const Heading: FC<HeadingProps> = ({ heading }) => {
  if (!heading?.text) {
    return null;
  }

  return <Text>{heading.text}</Text>;
};

export default Heading;
